module.exports = __webpack_public_path__ + "img/group-of-men.17808bf3.svg";